var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('card-title',{attrs:{"icon":'mdi-upload',"title":'Logo du Cabinet'}}),_c('logo-cabinet',{attrs:{"logo_cabinet_url":_vm.doctor.logo_cabinet_url,"logo_cabinet":_vm.doctor.logo_cabinet},on:{"saveLogoCabinet":_vm.saveLogoCabinet}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }